import React from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import Moment from "moment";
import { extendMoment } from "moment-range";
import CalenderWrapper from "./Calender.style";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";

const DragAndDropCalendar = withDragAndDrop(Calendar);
const moment = extendMoment(Moment);
const localizer = momentLocalizer(moment);

const Calender = (props) => {
  const { currentDate, calenderView, events } = props;

  console.log(currentDate);
  console.log(calenderView);
  console.log(events);

  const localeLang = "he";
  var startOfMonth = moment().startOf("month").toDate();
  const onView = (val) => {};
  return (
    <CalenderWrapper>
      <DragAndDropCalendar
        popup
        view={calenderView}
        onView={onView}
        date={moment(currentDate).toDate()}
        rtl={localeLang === "he"}
        selectable
        step={15}
        localizer={localizer}
        events={events}
        resizable
        defaultView={Views.MONTH}
        defaultDate={startOfMonth}
        style={{ height: "100%" }}
        drilldownView={Views.DAY}
        toolbar={false}
        showMultiDayTimes
        scrollToTime={new Date(1970, 1, 1, 8)}
        tooltipAccessor={null}
      />
    </CalenderWrapper>
  );
};

export default Calender;
